export default __webpack_public_path__ + "static/media/FreeLancerBG.06f4d6e1.jpg";